<script lang="ts">
  import InlineSvg from '../elements/InlineSvg.svelte';
  export let active = false;
  export let i = 0;
  let unread = true;

  $: readLetter(active);

  function readLetter(_: boolean) {
    if (active) {
      unread = false;
    }
  }
</script>

<li class="nsli" class:active role="button" on:click>
  <div class="content" class:unread>
    <h4 class="nsli-title">Weekly Issue {12 - i}</h4>
    <span class="nsli-date">{17 - i} July, 2022</span>
    <p class="nsli-items">Siter.io, Proudlist, Taskplane, Upnext, Hidden Bar, Desklamp</p>
  </div>
</li>

<style lang="scss">
  @import '../../styles/mixins';

  .nsli {
    border-left: 2px solid transparent;

    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: var(--color-blue-gray--800);
      cursor: pointer;
      padding: 12px 0;
      border-bottom: 1px solid var(--color-blue-gray--100);
      margin: 0px 16px 0px 20px;

      .nsli-title {
        @include font(Semibold);
        font-size: 14px;
        line-height: 18px;
        color: var(--color-blue-gray--500);
        margin-bottom: 6px;
      }

      .nsli-date {
        position: absolute;
        top: 14px;
        right: 16px;
        @include font();
        font-size: 10px;
        line-height: 130%;
        color: var(--color-blue-gray--500);
      }

      .nsli-items {
        @include font();
        font-size: 11px;
        line-height: 130%;
        color: var(--color-blue-gray--400);
      }

      &.unread::before {
        content: url('/img/icon/unread.svg');
        position: absolute;
        top: 14px;
        left: -14px;
      }
    }
    &.active {
      background-color: var(--color-blue--100);
      border-left: 2px solid var(--color-blue--500);
    }
  }

  :global(.dark-mode) {
    .nsli {
      border-left: 2px solid transparent;

      .content {
        color: var(--color-blue-gray--100);
        border-bottom: 1px solid var(--color-blue-gray--800);

        .nsli-title {
          color: var(--color-blue-gray--100);
        }

        .nsli-date {
          color: var(--color-blue-gray--400);
        }

        .nsli-items {
          color: var(--color-blue-gray--300);
        }
      }
      &.active {
        background-color: var(--color-blue--800);
        border-left: 2px solid var(--color-blue--500);
      }
    }
  }

  @media screen and (max-width: 600px) {
  }
</style>
